// extracted by mini-css-extract-plugin
export var addButton = "_gl-0";
export var border = "_gl-8";
export var check = "_gl-h";
export var danger = "_gl-6";
export var dropdownContainer = "_gl-1";
export var editModalBody = "_gl-j";
export var footerContainer = "_gl-i";
export var fullWidth = "_gl-a";
export var hide = "_gl-9";
export var icon = "_gl-3";
export var input = "_gl-7";
export var inputFlex = "_gl-b";
export var inputWrapper = "_gl-c";
export var manualFocus = "_gl-5";
export var optionButton = "_gl-4";
export var pillWrapper = "_gl-e";
export var pointer = "_gl-2";
export var showOverflow = "_gl-f";
export var tagsFlex = "_gl-d";
export var xButton = "_gl-g";